import { render, staticRenderFns } from "./category.vue?vue&type=template&id=2c5df4b0&scoped=true"
import script from "./category.vue?vue&type=script&lang=ts"
export * from "./category.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5df4b0",
  null
  
)

export default component.exports